import { render, staticRenderFns } from "./ImaLogo.vue?vue&type=template&id=447713b9&scoped=true&"
import script from "./ImaLogo.vue?vue&type=script&lang=js&"
export * from "./ImaLogo.vue?vue&type=script&lang=js&"
import style0 from "./ImaLogo.vue?vue&type=style&index=0&id=447713b9&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "447713b9",
  null
  
)

export default component.exports